import { Endpoint } from "../config";

export type CompanyEndpointType =
  | "companyList"
  | "clientProfilesList"
  | "clientInviteRequest"
  | "clientPendingRequest"
  | "clientRejectedRequest"
  | "tierCompanyList"
  | "permissionProfilesListByCompanyId"
  | "commodityList"
  | "contactsList"
  | "tierMasterProfiles";

export const companyEndpoints: Record<CompanyEndpointType, Endpoint> = {
  companyList: {
    url: "company-list/",
  },
  clientProfilesList: {
    url: "client-profiles-list/",
  },
  clientInviteRequest: {
    url: "client-invite-request/",
  },
  clientPendingRequest: {
    url: "client-pending-request/",
  },
  clientRejectedRequest: {
    url: "client-rejected-request/",
  },
  tierCompanyList: {
    url: "tier-companies",
  },
  permissionProfilesListByCompanyId: {
    url: "company-permission-profiles",
  },
  commodityList: {
    url: "commodity-list/",
  },
  contactsList: {
    url: "contacts/",
  },
  tierMasterProfiles: {
    url: "tier-master-profiles/",
  },
};
